import { Component, Input } from "@angular/core";

@Component({
    selector: "app-auto-open-menu",
    template: `
    <div
      class="app-nav-item"
      [matMenuTriggerFor]="menu"
      #menuTrigger="matMenuTrigger"
      (mouseenter)="mouseEnter(menuTrigger)"
      (mouseleave)="mouseLeave(menuTrigger)"
    >
      <ng-content select="[trigger]"></ng-content>
    </div>
    <mat-menu
      #menu="matMenu"
      [hasBackdrop]="false"
      [class]="size > 4 ? 'navigationMenu large' : 'navigationMenu'"
      xPosition="after"
    >
      <div
        (mouseenter)="mouseEnter(menuTrigger)"
        (mouseleave)="mouseLeave(menuTrigger)"
      >
        <ng-content select="[content]"></ng-content>
      </div>
    </mat-menu>
  `,
    standalone: false
})
export class AutoOpenMenuComponent {
  timedOutCloser: any;
  constructor() {}
  @Input() size: any;

  mouseEnter(trigger: any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }
  mouseLeave(trigger: any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }
}
